<template>
	<div class="app-container">

		<h1>{{title}}</h1>

		<input type="text" id="logsFilter" class="form-control" v-model="logsFilterTable.startAt" />
		<table class="table loading-container">
			<thead>
				<tr>
					<th scope="col">#</th>
					<th scope="col">Date</th>
					<th scope="col">Domain id</th>
					<th scope="col">Domain</th>
					<th scope="col">Action</th>
					<th scope="col">Message</th>
					<th scope="col">User</th>
					<th scope="col">stackTrace</th>
					<th scope="col"></th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(l, index) in logsA" :key="index">
					<td>{{ index + 1 }}</td>
					<td>{{ l.createdOn | hyperDate }}</td>
					<td>{{ l.domainId }}</td>
					<td>{{ l.domain }}</td>
					<td>{{ l.action }}</td>
					<td>{{ l.message }}</td>
					<td>{{ l.user }}</td>
					<td>{{ l.stackTrace }}</td>
					<td class="text-right">
						<button
							title="Info"
							class="btn btn-secondary"
							@click="view(l)"
						>
							<i class="fas fa-eye"></i>
						</button>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>
<script>


export default {
	name: 'LogsTable',
	components: {
	},
	props: {
		logsA: [],
		logsFilterTable: {},
		title: String
	},
	data() {
		return {
		
		};
	},
	methods: {
	
		close() {
			this.$emit('close');
		},
	},
};
</script>

<style scoped>
	.h1-buttons.no-verti::after {
		display: none;
	}
	.alert {
		text-align: start;
	}
</style>